// extracted by mini-css-extract-plugin
export default {"totalReturn":"styles_totalReturn__h8BQQ","title":"styles_title__M6zjs","label":"styles_label__btk9f","value":"styles_value__+xOyw","extra":"styles_extra__AvCt8"};